module.exports = __webpack_public_path__ + "img/ha.895d18f1.jpg";